import { render, staticRenderFns } from "./EquiposDeportistasList.vue?vue&type=template&id=b13046c2"
import script from "./EquiposDeportistasList.vue?vue&type=script&setup=true&lang=js"
export * from "./EquiposDeportistasList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports